module.exports = __webpack_public_path__ + "media/images/front/mid_g/banner_cs_app_pc-8b5052fd1fed1cf24b55043cdcbf70ac.png";